enum JobStatuses {
    Completed = 1,
    Errored = 2,
    InProgress = 3,
}

export default JobStatuses;
